<swiper-container
  navigation="true"
  [pagination]="paginationConfiguration"
  [config]="swiperConfig"
  init="false"
  class="PhotoCarousel__Swiper"
  [ngClass]="{ 'PhotoCarousel__Swiper--Fullscreen': fullScreen }"
  #swiper
>
  @for (photo of photos; track photo; let i = $index) {
    <swiper-slide>
      <img
        class="PhotoCarousel__Image"
        [src]="photo.url"
        alt="{{ photo.alt }}"
      />
    </swiper-slide>
  }
</swiper-container>
